import { DriverWorkShift } from "@/models/operationPlans";
import {
  DriverWorkCyclesConstants,
  getTimeLabel,
} from "@/pages/DriverWorkCycles/DriverWorkCyclesConstants";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CommonButton } from "../common/buttons/CommonButton";

export type DriverWorkShiftDetailTabProps = {
  driverWorkShifts: DriverWorkShift[];
  onClickAdd: () => void;
  onClickEdit: (shiftId: number) => void;
};

export const DriverWorkShiftDetailTab = ({
  driverWorkShifts,
  onClickAdd,
  onClickEdit,
}: DriverWorkShiftDetailTabProps) => (
  <TableContainer
    sx={{ width: "100%", backgroundColor: "#fff" }}
    className="table-container-width"
  >
    <Table size="small" sx={{ width: "100%" }} className="list-head">
      <TableHead>
        <TableRow>
          <TableCell className="table-cell-width-80">
            {DriverWorkCyclesConstants.DriverWorkShiftName}
          </TableCell>
          <TableCell className="table-cell-width-80">
            {DriverWorkCyclesConstants.DayOff}
          </TableCell>
          <TableCell className="table-cell-width-custom">
            {DriverWorkCyclesConstants.WeekDay}
          </TableCell>
          <TableCell className="table-cell-width-custom">
            {DriverWorkCyclesConstants.Holiday}
          </TableCell>
          <TableCell>{DriverWorkCyclesConstants.Description}</TableCell>
          <TableCell sx={{ textAlign: "right", pr: 0 }}>
            <CommonButton btnType="Add" onClickBtn={onClickAdd} />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {driverWorkShifts.map((row) => (
          <TableRow key={row.id} hover>
            <TableCell>{row.shortName ?? ""}</TableCell>
            <TableCell>
              {row.weekdayIsDayOff && row.holidayIsDayOff
                ? DriverWorkCyclesConstants.DayOff[0]
                : "ー"}
            </TableCell>
            <TableCell>{getTimeLabel(false, row)}</TableCell>
            <TableCell>{getTimeLabel(true, row)}</TableCell>
            <TableCell>{row.description ?? ""}</TableCell>
            <TableCell sx={{ textAlign: "right", pr: 0 }}>
              <CommonButton
                btnType="Edit"
                onClickBtn={() => onClickEdit(row.id ?? 0)}
                disabled={!!row.isDefault}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
